/*
 * Public API Surface of plugin-event-templates
 */

export * from './lib/event-templates.module';
